import React from 'react';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import TranslatorPage from './TranslatorPage';

const TranslatorProject: React.FC = () => {
  const { t } = useLanguage();


  return (
    <div className="max-w-7xl mx-auto">
      <TranslatorPage />
    </div>
  );
};

export default TranslatorProject;
